<template>
  <div class="task">
    <v-progress-circular v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>

  <v-row>
    <v-col cols="12" sm="12" > 
      <v-card>
        <v-row align="center" class="list px-3 mx-auto">
          <v-col cols="4" sm="2">
            <v-select
              v-model="searchOption"
              :items="searchOptions"
              :label="langC.SearchBy"
              clearable
              @change="handleSearchOption"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field v-model="searchName" :label="langC.SearchBy"></v-text-field>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn small @click="page = 1; defaultInit();">
              {{langC.Search}}
            </v-btn>
          </v-col>
          <v-col cols="5" sm="4">
            <v-pagination
              v-model="page"
              :length="totalPages"
              total-visible="7"
              next-icon="mdi-menu-right"
              prev-icon="mdi-menu-left"
              @input="handlePageChange"
            ></v-pagination>
            
          </v-col>
          <v-col cols="4" sm="1" >
            Total:{{totalItems}}
          </v-col>
          <v-col cols="4" sm="1" >
            <v-select
              v-model="pageSize"
              :items="pageSizes"
              :label="langC.ItemsPerPage"
              @change="handlePageSizeChange"
            ></v-select>
        </v-col>
      </v-row>
     </v-card>
    </v-col>
  </v-row> 

  <v-row>
    <v-col cols="12" sm="12"> 
      <v-card>
        <v-card-title>
          Opzstat
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
            dense
            :headers="headers"
            :items="items"
            item-key="id"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="navigateTo"
          >

          <template v-slot:[`item.VrstaIzvjesca`]="{ item }">
              <span>{{ parseInt(item.VrstaIzvjesca) }}</span>
          </template>
          <template v-slot:[`item.Locked`]="{ item }">
            <span v-if="item.Locked"><v-icon>mdi-check</v-icon></span>
          </template>
           <template v-slot:[`item.DatumOd`]="{ item }">
              <span>{{ localDate(item.DatumOd) }}</span>
          </template>
          <template v-slot:[`item.DatumDo`]="{ item }">
              <span>{{ localDate(item.DatumDo) }}</span>
          </template>

          <template v-slot:[`item.NaDan`]="{ item }">
              <span>{{ localDate(item.NaDan) }}</span>
          </template>
          <template v-slot:[`item.NisuNaplaceniDo`]="{ item }">
              <span>{{ localDate(item.NisuNaplaceniDo) }}</span>
          </template>

          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
      </v-card>
     </v-col>
    </v-row> 
  </div>
</template>

<script>
import OpzstatHeadService from '@/services/OpzstatHeadService'

import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import moneyFormat from '@/snippets/moneyFormat'
import dateFormat from '@/snippets/dateFormat'

export default {
  name: 'opzstatheadlist',
  data () {
    return {
      documentName: '',
      documentNameLoc: '',
      docside: 0,
      msg: '',
      items: [],
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        MLType: 1
      },
      columns: [],
      rows: [],
      lang: {},
      langC: {},
      saving: false,
      searchName: "",
      page: 1,
      totalPages: 0,
      pageSize: 30,
      pageSizes: [10, 30, 50],
      searchOption: '',
      searchOptions: [],
      totalItems: 0,
      bookTypeSelected: {},
      show: 0
    }
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.langC = commHr;
      }
    this.defaultInit()
  },
  methods: {
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
     localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    async defaultInit() {
      this.$store.dispatch('seteditItem', 0)
      this.headers = []
      this.searchOptions = []
       
      const query = this.setQuery()
      if (query.searchItem && this.searchName) {
        query.searchName =  this.searchName.trim()
        await this.$store.dispatch('setOnPage', query)
      }
      if (query.searchItem && query.searchName) {
        this.searchOption = query.searchItem
        this.searchName = query.searchName 
      }
      this.saving = true
 
      await OpzstatHeadService.indexlist(query)
      .then(res => {
        this.items = res.data.opzstathead ? res.data.opzstathead : []
        this.totalItems = res.data.totalPages
        this.totalPages = parseInt(res.data.totalPages / this.pageSize) + 1
      })
      .catch(err => {
        this.havealert = !this.havealert
        this.havemssgalert = 'Error' + err
      })
      this.saving = false
      this.documentName = this.$store.state.documentActiv
      this.documentNameLoc = this.$store.state.documentActivLoc

      this.headers.push(
        { text: 'Na Dan', align: 'right', sortable: true, value: 'NaDan', width: '100px' },
        { text: 'Nisu Naplaceni Do', align: 'left', sortable: true, value: 'NisuNaplaceniDo', width: '40px' },
        { text: 'DatumOd', align: 'left', sortable: true, value: 'DatumOd', width: '60px'},
        { text: 'DatumDo', align: 'left', sortable: true, value: 'DatumDo', width: '60px'},
        { text: 'OIB', align: 'left', sortable: true, value: 'OIB', width: '50px' },
        { text: 'Vrsta Izvjesca', align: 'left', sortable: true, value: 'VrstaIzvjesca', width: '50px' },
        { text: 'Naziv', align: 'left', sortable: true, value: 'Naziv', width: '80px' },
        { text: 'Ime', align: 'center', value: 'Ime', width: '100px' },
        { text: 'Prezime', align: 'left', sortable: true, value: 'Prezime', width: '80px' },
        
        { text: 'DbId', value: 'id', width: '60px' }
      )
      this.searchOptions.push(
        {
          text: 'Vrsta Izvjesca', align: 'left', sortable: true, value: 'VrstaIzvjesca', width: '60px'
        },
        { text: 'Naziv', align: 'left', sortable: true, value: 'Naziv', width: '50px' },
        { text: 'Prezime', align: 'center', value: 'Prezime', width: '100px' },
      )
    },
    async navigateTo (params) {
      console.log("🚀 ~  navigateTo ~ params", params)
      
      await this.$store.dispatch('seteditItem', 1)
      this.$store.dispatch('setretPath', 'opzstathead')
      await this.$store.dispatch('setDocumentid', params.id)
      this.$router.push({
        name: 'opzstatheaddetail'
      })
    },

    async handlePageChange(value) {      
      const query = this.$store.state.onPage
      query.page = value - 1;
      this.page = value
      await this.$store.dispatch('setOnPage', query)
      this.defaultInit();
    },

    async handlePageSizeChange(size) {
      const query = this.$store.state.onPage
      query.pageSize = size;
      query.page = 1;
      this.pageSize = size
      await this.$store.dispatch('setOnPage', query)
      this.defaultInit();
    },

    async handleSearchOption(option) {
      this.searchOption = option
      const query = this.$store.state.onPage
      query.searchItem = option
      query.page = 0
      await this.$store.dispatch('setOnPage', query)
    },

    setQuery() {
      const haveOnPage = this.$store.state.onPage
      const query = {}
      if (this.$store.state.companyid) {
        query.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        query.businessYear = this.$store.state.businessYear
      }
      query.searchName = haveOnPage.searchName ? haveOnPage.searchName.trim() : null
      query.page = haveOnPage.page ? haveOnPage.page : 0
      this.page  = query.page + 1
      query.pageSize = haveOnPage.pageSize ? haveOnPage.pageSize : 30
      this.pageSize = query.pageSize
      query.searchItem = haveOnPage.searchItem ? haveOnPage.searchItem : null
      return query
    },
    async defaultQuery() {
      const query = {}
      if (this.$store.state.companyid) {
        query.CompanyId = this.$store.state.companyid
      }
      query.searchName = null
      query.page =  0
      query.pageSize =  30
      query.searchItem =  null
      await this.$store.dispatch('setOnPage', query)
      this.searchName = ""
      this.page = 1
      this.totalPages = 0
      this.pageSize = 30
      this.mainQuery = query
    },
    async initAgain () {
      this.defaultQuery()
      this.defaultInit()
    }
  },
  computed: {

  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
